import(/* webpackMode: "eager" */ "/app/components/BlogCard.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")